<template>
    <div>
        <b-col>
            <p>
                Enabling travel insurance for online bookings will give the
                guest an opportunity to purchase a travel insurance at the end
                of the online booking process.
            </p>
            <p>
                Travel Insurance is
                <strong>{{ insuranceStatus }}</strong> for online bookings.
            </p>
            <b-button
                @click="toggleTravelInsuranceStatus"
                variant="outline-primary"
                >{{ travelInsuranceButtonCaption }} TRAVEL INSURANCE</b-button
            >
        </b-col>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import API from './../../../api';

    export default {
        name: 'TravelInsuranceSetup',
        computed: {
            ...mapGetters('travelInsurance', ['travelInsuranceStatus']),
            insuranceStatus() {
                return this.travelInsuranceStatus ? 'enabled' : 'disabled';
            },
            travelInsuranceButtonCaption() {
                return this.travelInsuranceStatus ? 'DISABLE' : 'ENABLE';
            },
        },
        methods: {
            ...mapActions('travelInsurance', ['fetchStatus']),
            async toggleTravelInsuranceStatus() {
                const updateSuccessMessage = status =>
                    `Travel insurance successfully ${status}.`;
                const updateErrorMessage =
                    'Could not update Travel Insurance status.';

                try {
                    await API.post(`app/travel-insurance/issuances-setup/toggle/`);
                    this.successToast({text: updateSuccessMessage(this.insuranceStatus) })
                } catch (error) {
                    this.errorToast({text: updateErrorMessage })
                } finally {
                    await this.fetchStatus();
                }
            },
        },
    };
</script>

<style lang="scss" scoped></style>
